import { AuthenticationFlowType } from './enums';
import { IAuthenticationFlowRunner, IAuthenticationFlowFactory } from './models';
import { loadCrossAuthenticationFlowRunner } from './flow-runners/cross-authentication-flow-runner.loader';
import { loadRegularAuthenticationFlowRunner } from './flow-runners/regular-authentication-flow-runner.loader';
import { loadBiometricsAuthenticationFlowRunner } from './flow-runners/biometrics-authentication-flow-runner.loader';

export class AuthenticationFlowFactory implements IAuthenticationFlowFactory {
    constructor() {}
    public async create(flowType: AuthenticationFlowType): Promise<IAuthenticationFlowRunner> {
        let authenticationFlowRunner: IAuthenticationFlowRunner;

        switch (flowType) {
            case AuthenticationFlowType.Regular: {
                authenticationFlowRunner = await loadRegularAuthenticationFlowRunner();
                break;
            }
            case AuthenticationFlowType.Cross: {
                authenticationFlowRunner = await loadCrossAuthenticationFlowRunner();
                break;
            }
            case AuthenticationFlowType.Biometrics: {
                authenticationFlowRunner = await loadBiometricsAuthenticationFlowRunner();
                break;
            }
        }

        return authenticationFlowRunner;
    }
}
